import { VehicleState } from './vehicle.interfaces';
import { VehicleAction } from './vehicle.actions';
import { reducer as vehiclesReducer } from './vehicles/vehicles.reducer';
import { combineReducers } from '@ngrx/store';
export function vehicleReducer(state: VehicleState, action: VehicleAction): VehicleState {
  switch (action.type) {
    default: {
      return state;
    }
  }
}

const myReducers = {
  vehicles: vehiclesReducer,
  vehicleReducer
};

export function createReducer(asyncReducers = {}) {
  let allReducers = Object.assign(myReducers, asyncReducers);
  return combineReducers(allReducers);
}

export function appReducer(state: any, action: any) {
  return createReducer()(state, action);
}
export const reducer = combineReducers(myReducers);
